import type { RouteRecordRaw } from 'vue-router';
import { Authenticated, ModelBindings, Require2FA } from '~/middlewares';

export const clientRoutes: RouteRecordRaw[] = [
    {
        path: '/',
        component: () => import('~/views/GenericLayout.vue'),
        meta: {
            middlewares: [Authenticated, Require2FA, new ModelBindings('client')],
            showChildrenInNavbar: true,
        },
        children: [
            {
                name: 'index',
                path: '',
                component: () => import('~/views/Index.vue'),
                meta: {
                    icon: 'server',
                },
            },
            {
                name: 'account.settings',
                path: 'account',
                component: () => import('~/views/layouts/TabsLayout.vue'),
                redirect: { name: 'account.settings.details' },
                meta: {
                    icon: 'user',
                    nav: {
                        tabs: [
                            {
                                name: 'account.settings.details',
                                label: 'navigation.account.settings.details.title',
                                route: { name: 'account.settings.details' },
                                active: true,
                            },
                            {
                                name: 'account.settings.2fa',
                                label: 'navigation.account.settings.2fa.title',
                                route: { name: 'account.settings.2fa' },
                            },
                        ],
                    },
                },
                children: [
                    {
                        name: 'account.settings.details',
                        path: '',
                        component: () => import('~/views/account/Index.vue'),
                    },
                    {
                        name: 'account.settings.2fa',
                        path: '2fa',
                        component: () => import('~/views/account/2fa/Index.vue'),
                    },
                ],
            },
            // Redirect for backwards compatability with v1
            {
                name: 'account.sso',
                path: 'account/sso',
                meta: {
                    hidden: true,
                },
                redirect: (to) => {
                    return {
                        name: 'account.settings',
                        query: to.query,
                    };
                },
            },
            {
                name: 'account.security',
                path: 'account/security',
                component: () => import('~/views/account/Security.vue'),
                meta: {
                    icon: 'lock',
                },
            },
            {
                name: 'account.ssh-keys',
                path: 'account/ssh-keys',
                component: () => import('~/views/account/SSHKeys.vue'),
                meta: {
                    icon: 'key',
                },
            },
        ],
    },
];
